import React from 'react';
import TagsInput from 'react-tagsinput';

import 'react-tagsinput/react-tagsinput.css';

import './styles.scss';

const TagInput = ({ tags, handleChange, ...other }) => {
  const delimitersMap = {
    COMMA: 188,
    ENTER: 13,
    TAB: 9,
    SPACE: 32,
    SEMICOLON: 186
  };

  return (
    <TagsInput
      value={tags}
      onChange={handleChange}
      addKeys={Object.values(delimitersMap)}
      addOnBlur={true}
      {...other}
    />
  );
};

export default TagInput;
